import React, { useEffect, useState } from "react";
import {
  Box,
  Avatar,
  TableCell,
  TableRow,
  IconButton,
  Menu,
  MenuItem,
  FormControl,
  Select,
  Typography,
  Tabs,
  Tab,
  Tooltip,
} from "@mui/material";
import PageTitle from "../../../components/pageTitle/PageTitle";
import ManageUser from "./ManageUser";
import LeadAllocation from "./LeadAllocations/LeadAllocation";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { MoreVert as MoreIcon } from "@mui/icons-material";
import {
  getAllSubUserAction,
  setAddSubUserResponse,
  setConfirmationEmailSuccessAction,
  setDeleteSubUserResponse,
  setStaffConfirmationEmailAction,
  updateSubUserResponse,
} from "../../../store/reducers/subUserSlice";
import { setNotificationAction } from "../../../store/reducers/mmymSlice";
import TableDesign, {
  TableHeading,
} from "../../../components/common/table/TableDesign";
import StatusBadge from "../../../components/common/StatusBadge";
import DeleteUser from "./DeleteUser";
import { Lens } from "@mui/icons-material";
import ResetPasswordPopup from "./ResetPasswordPopup";
import ActivationUser from "./ActivationUser";
import verifyEmail from "../../../assets/images/checked.png";
import AlertPopup from "../../../components/common/alertPopup/AlertPopup";

interface FilterOption {
  page: number;
  limit: number;
  orderBy: string;
  orderIn: string;
}
interface User {
  name: string;
  aka_name: string;
  role: string;
  email: string;
  status: string; // Adjust based on actual API structure
  [key: string]: any; // For additional properties, if any
}

const UserDetails = () => {
  const [open, setOpen] = useState(false); // State variable to manage dialog open/close
  const [selectedUser, setSelectedUser] = useState<User | null>(null);
  const [title, setTitle] = useState("");
  const [deleteModelShow, setDeleteModelShow] = useState(false);
  const [resetPasswordModalShow, setResetPasswordModalShow] = useState(false);
  const [activationModalShow, setActivationModalShow] = useState(false);
  const [confirmationEmailModalShow, setConfirmationEmailModalShow] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const tableHeadings: TableHeading[] = [
    { label: "#", align: "left" },
    { label: "Name", align: "left" },
    { label: "Alias Name", align: "left" },
    { label: "Role", align: "left" },
    { label: "Email", align: "left" },
    { label: "Sender Signature", align: "left" },
    { label: "Status", align: "center" },
    { label: "Action", align: "center" },
  ];

  const dispatch = useDispatch();
  const {
    users,
    isAddSubUserSuccess,
    isUpdateSubUserSuccess,
    staffPagination,
    isDeleteResponseSuccess,
    isUserResetPasswordSuccess,isConfirmationEmailSuccess
  } = useSelector((state: any) => state.subUser);
  const [filterValue, setFilterValue] = useState("");
  const [filterOption, setFilterOption] = useState<FilterOption>({
    page: 1,
    limit: 10,
    orderBy: "created_at",
    orderIn: "DESC",
  });

  const [isLoader] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openDown = Boolean(anchorEl);
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleFilterChange = (event: any) => {
    setFilterValue(event.target.value);
  };

  const handleOpen = () => {
    setOpen(true);
    setTitle("Add User");
  };
  const handleClose = () => {
    setOpen(false);
    setDeleteModelShow(false);
    setResetPasswordModalShow(false);
    setConfirmationEmailModalShow(false);
    setSelectedUser(null);
    setTitle("");
    dispatch(setNotificationAction({ message: [], severity: "info" }));
    setAnchorEl(null);
  };
  const handleEditOpen = () => {
    setOpen(true);
    setAnchorEl(null);
    // setSelectedUser(user);
    setTitle("Edit User");
  };

  const handleDeleteOpen = () => {
    setDeleteModelShow(true);
    setAnchorEl(null);
    // setSelectedUser(user);
    setTitle("Delete User");
  };

  const handleResetOpen = () => {
    setResetPasswordModalShow(true);
    setAnchorEl(null);
    setTitle("Reset Password");
  };

  const handleActivation = () => {
    setActivationModalShow(true);
    setAnchorEl(null);
    setTitle("Activation");
  };

  const handleResendConfirmationEmail = () => {
    setConfirmationEmailModalShow(true);
    setAnchorEl(null);
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  useEffect(() => {
    dispatch(getAllSubUserAction({ status: filterValue }));
    return () => {
      dispatch(setNotificationAction({ message: [], severity: "info" }));
    };
  }, [filterValue]);

  useEffect(() => {
    if (
      isAddSubUserSuccess ||
      isUpdateSubUserSuccess ||
      isDeleteResponseSuccess ||
      isUserResetPasswordSuccess ||isConfirmationEmailSuccess
    ) {
      dispatch(getAllSubUserAction({ status: filterValue }));
      dispatch(setAddSubUserResponse(false));
      dispatch(updateSubUserResponse(false));
      dispatch(setDeleteSubUserResponse(false));
      dispatch(setConfirmationEmailSuccessAction(false));
      setDeleteModelShow(false);
      setResetPasswordModalShow(false);
      setActivationModalShow(false);
      setSelectedUser(null);
    }
  }, [
    isAddSubUserSuccess,
    isUpdateSubUserSuccess,
    isDeleteResponseSuccess,
    isUserResetPasswordSuccess,isConfirmationEmailSuccess
  ]);

  const handleSendConfirmationEmail = () => {
    if (selectedUser) {
      dispatch(
        setNotificationAction({ message: [], severity: "info" }),
      );
      dispatch(
        setStaffConfirmationEmailAction({
          staffId: selectedUser?.staff_id,
          senderId: selectedUser?.staff_email_sender_signature_id,
        }),
      );
    }
  };

  console.log("selectedUser", selectedUser);

  return (
    <>
      {confirmationEmailModalShow && (
        <AlertPopup
          open={confirmationEmailModalShow}
          title="Resend Confirmation Email"
          content={`Are you sure, you want to resend confirmation link to this user?`}
          submitHandler={() => {
            handleSendConfirmationEmail();
          }}
          onHide={handleClose}
          isError={false}
        />
      )}
      {activationModalShow && (
        <ActivationUser
          selectUser={selectedUser}
          alertModalShow={activationModalShow}
          setAlertModelShow={setActivationModalShow}
          onHide={handleClose}
        />
      )}
      {resetPasswordModalShow && (
        <ResetPasswordPopup
          clientDetails={selectedUser}
          resetPasswordModalShow={resetPasswordModalShow}
          setResetPasswordModalShow={setResetPasswordModalShow}
          onHide={handleClose}
        />
      )}
      {deleteModelShow && (
        <DeleteUser
          selectUser={selectedUser}
          alertModalShow={deleteModelShow}
          setAlertModelShow={setDeleteModelShow}
          onHide={handleClose}
        />
      )}
      {open && (
        <ManageUser
          selectUser={selectedUser}
          open={open}
          onHide={handleClose}
          title={title}
        />
      )}
      <PageTitle
        title="User Management"
        button="Add Users"
        onClick={handleOpen}
      />
      <Box
        sx={{ borderBottom: 1, borderColor: "divider", marginBottom: "20px" }}
      >
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          aria-label="user management tabs"
        >
          <Tab label="User Details" id="tab-0" aria-controls="tabpanel-0" />
          {/* <Tab label="Lead Allocation" id="tab-1" aria-controls="tabpanel-1" /> */}
        </Tabs>
      </Box>

      {activeTab === 0 && (
        <>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <Typography sx={{ marginRight: "10px", minWidth: "40px" }}>
              Filter By:
            </Typography>
            <FormControl sx={{ width: "260px", right: 0 }}>
              {/* <InputLabel id="filter-select-label">Filter By</InputLabel> */}
              <Select
                sx={{
                  height: "36px",
                  padding: "2px 4px",
                  marginBottom: "10px",
                }}
                // labelId="filter-select-label"
                id="filter-select"
                value={filterValue}
                onChange={handleFilterChange}
                // label="Filter By"
                displayEmpty
              >
                <MenuItem value="">All</MenuItem>
                <MenuItem value={"ACTIVE"}>Active</MenuItem>
                <MenuItem value={"PENDING"}>Pending</MenuItem>
                <MenuItem value={"INACTIVE"}>Inactive</MenuItem>
                <MenuItem value={"DELETED"}>Deleted</MenuItem>
              </Select>
            </FormControl>
          </Box>
          <Box
            sx={{
              bgcolor: "#fff",
              height: { xs: "auto", sm: "60vh" },
              border: "1px solid #d1cfcf",
              borderRadius: "5px",
              padding: "0px",
              overflow: "hidden",
            }}
          >
            <TableDesign
              tableHeadings={tableHeadings}
              tableHeadColor={"#02906f"}
              cellColor={"#fff"}
              pagination={users.length > 0 ? staffPagination : null}
              isLoader={isLoader}
              stickyHeader={true}
              filterOption={filterOption}
              setFilterOption={setFilterOption}
              extraCSS={{
                height: "calc(100%)",
              }}
            >
              {users.length > 0 ? (
                users?.map((val: any, idx: number) => (
                  <TableRow
                    key={val?.client_id}
                    sx={{
                      cursor: "pointer",
                      marginTop: "10px",
                      padding: "4px !important",
                      borderRadius: "20px !important",
                      "&:hover": {
                        backgroundColor: "#f0f0f0",
                        outline: "2px solid #f0f0f0",
                        borderRadius: "0px !important",
                        outlineOffset: "-2px !important",
                      },
                    }}
                  >
                    <TableCell align="left">
                      {staffPagination?.currentPage > 1
                        ? (staffPagination?.currentPage - 1) * 10 + (idx + 1)
                        : idx + 1}
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{
                        // padding: "0px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Avatar sx={{ bgcolor: "grey.300", marginRight: 2 }} />
                      {val?.name}
                    </TableCell>
                    <TableCell>{val?.aka_name}</TableCell>
                    <TableCell>
                      {Array.isArray(val?.roles)
                        ? val.roles.join(", ")
                        : val?.roles || ""}
                    </TableCell>
                    <TableCell>
                      {val.email}{" "}
                     {/* {val?.is_staff_email_signature_confirmed && (
                      <Tooltip title="Email Verified">
                      <img
                        style={{ width: "20px",marginLeft:'5px' }}
                        src={verifyEmail}
                        alt="Verified"
                      />
                      </Tooltip>
                    )} */}
                    </TableCell>
                    <TableCell> {!val?.roles?.some(
                        (role: any) => role.toLowerCase() === "tenant",
                      ) && 
                      (val?.is_staff_email_signature_confirmed ? "Verified" : "Not Verified")}</TableCell>
                    <TableCell align="center">
                      <StatusBadge status={val.status} />
                    </TableCell>
                    <TableCell align="center">
                      {!val?.roles?.some(
                        (role: any) => role.toLowerCase() === "tenant",
                      ) && (
                        <IconButton
                          id="basic-button"
                          aria-controls={openDown ? "basic-menu" : undefined}
                          aria-haspopup="true"
                          aria-expanded={openDown ? "true" : undefined}
                          onClick={(e) => {
                            handleClick(e);
                            setSelectedUser(val);
                          }}
                        >
                          <MoreIcon />
                        </IconButton>
                      )}

                      <Menu
                        sx={{
                          boxShadow: "none",
                          border: "2px solid #eeecef",
                          "& .MuiPaper-root": {
                            boxShadow: "none", // Removes shadow on the paper element of the menu
                            border: "2px solid #eeecef",
                          },
                          top: "0px",
                        }}
                        // className={classes.menuBox}
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={openDown}
                        onClose={handleClose}
                        MenuListProps={{
                          "aria-labelledby": "basic-button",
                        }}
                      >
                        {selectedUser && selectedUser?.status !== "DELETED" && (
                          <MenuItem onClick={() => handleEditOpen()}>
                            <Lens
                              style={{
                                height: "4px",
                                width: "4px",
                                marginRight: "4px",
                              }}
                            />
                            Edit
                          </MenuItem>
                        )}
                        {selectedUser && selectedUser?.status === "DELETED" ? (
                          <MenuItem onClick={() => handleActivation()}>
                            <Lens
                              style={{
                                height: "4px",
                                width: "4px",
                                marginRight: "4px",
                              }}
                            />
                            Active
                          </MenuItem>
                        ) : (
                          <>
                            <MenuItem onClick={() => handleResetOpen()}>
                              <Lens
                                style={{
                                  height: "4px",
                                  width: "4px",
                                  marginRight: "4px",
                                }}
                              />
                              Reset Password
                            </MenuItem>
                            <MenuItem onClick={() => handleDeleteOpen()}>
                              <Lens
                                style={{
                                  height: "4px",
                                  width: "4px",
                                  marginRight: "4px",
                                }}
                              />
                              Delete
                            </MenuItem>
                            {selectedUser?.staff_email_sender_signature_id && (
                              <MenuItem onClick={() => handleResendConfirmationEmail()}>
                                <Lens
                                  style={{
                                    height: "4px",
                                    width: "4px",
                                    marginRight: "4px",
                                }}
                              />
                              Resend Confirmation Email
                            </MenuItem>
                          )}
                          </>
                        )}
                      </Menu>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={7}>
                    <Box
                      sx={{
                        height: "60vh",
                        display: "flex",
                        // alignItems: "center",
                        justifyContent: "center",
                        position: "relative",
                      }}
                    >
                      <span
                        style={{
                          position: "absolute",
                          fontSize: "1rem",
                          color: "#4A4A4A",
                          top: "100px",
                        }}
                      >
                        {"No Users Found."}
                      </span>
                    </Box>
                  </TableCell>
                </TableRow>
              )}
            </TableDesign>
          </Box>
        </>
      )}

      {activeTab === 1 && <LeadAllocation />}
    </>
  );
};

export default UserDetails;
